export function shuffleArray<V>(arr: V[]) {
  for (var i = arr.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = arr[i];
    arr[i] = arr[j];
    arr[j] = temp;
  }
}

export function fixedShuffle<V extends { shuffle?: boolean; rank?: number }>(arr: V[]) {
  const shuffleable = arr.filter(v => v.shuffle)
  const items = arr.filter(v => typeof v.rank !== 'number')
  const ranks = arr.reduce((acc, v) => {
    if (typeof v.rank === 'number') {
      if (!acc[v.rank]) acc[v.rank] = []
      acc[v.rank].push(v)
    }
    return acc
  }, {} as { [rank: number]: V[] })
  
  shuffleArray(shuffleable)

  return items.reduce((acc, item, i) => {
    if (ranks[i]) {
      acc.push(...ranks[i])
    }
    if (item.shuffle) {
      const shuffled = shuffleable.pop()
      if (shuffled) {
        acc.push(shuffled)
      }
    } else {
      acc.push(item)
    }
    return acc
  }, [] as V[])
  .filter(v => v)
}

export function jaccardSort<V extends { title: string }>(arr: V[], title: string) {
  arr.sort((a, b) => {
    return calculateJaccardSimilarity(b.title, title) - calculateJaccardSimilarity(a.title, title)
  })
}

const tokenized = new Map<string, Set<string>>()
const blacklist = new Set(['of', 'the', 'a', 'at', 'to', 'up', 'down', 'from', 'for', 'on', 'about', 'he', 'she', 'they', 'his', 'her', 'them', 's', 'i'])

const tokenize = (text: string): Set<string> => {
  const cached = tokenized.get(text)
  if (cached) return cached
  const set = new Set(text.toLowerCase().replace(/é/g, 'e').split(/\W+/).filter(word => word.length > 0 && !blacklist.has(word)));
  tokenized.set(text, set)
  return set
};

const calculateJaccardSimilarity = (title1: string, title2: string) => {
  // Tokenize both titles
  const title1Set = tokenize(title1);
  const title2Set = tokenize(title2);

  // Intersection of sets
  const intersection = new Set(Array.from(title1Set).filter(word => title2Set.has(word)));

  // Union of sets
  const union = new Set([...Array.from(title1Set), ...Array.from(title2Set)]);

  // Calculate Jaccard similarity
  const similarity = intersection.size / union.size;
  return similarity;
}